import {
    clusterListRequest,
    clusterItemRequest
} from "../../../actions/cluster-actions"
import buildListContainer from "../../common/build-list-container"
import ClusterListItem from "./ClusterListItem"
import ClusterListItemShadow from "./ClusterListItemShadow"

export default buildListContainer(
    ClusterListItem,
    ClusterListItemShadow,
    clusterListRequest,
    clusterItemRequest,
    "clusters"
)
